<template>
    <div class="starLevel">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '/publicList', query: { documentTitle: cateName } }">{{ cateName }}</el-breadcrumb-item>
                      <el-breadcrumb-item>正文</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="top">
                        <div class="contentLeft">
                            <div class="title">
                                <img src="../../assets/img/index/companyIcon.png" alt="">
                                <span style="margin-left: 10px;">{{detail.name}}</span>
                            </div>
                            <div class="info">
                                <p>统一社会信用代码: {{detail.creditCode}}</p>
                                <p>法定代表人: {{detail.legalName}}</p>
                                <p>成立日期: {{detail.establishmentDate}}</p>
                                <p>注册地址: {{detail.address}}</p>
                                <p>登记机关：{{detail.registrationAuthority}}</p>
                                <p>经营范围：{{detail.businessScope}}</p>
                            </div>
                        </div>
                        <div class="contentRight" v-if="detail.certificateUrl != '' && detail.certificateUrl != null">
                            <div>
                                <span v-if="isNtoImg" style="cursor: pointer;" @click="lookFile(detail.certificateUrl)">点击查看文件</span>
                                <div v-else>
                                    <el-image v-if="isSightcing" class="img1" :src="detail.certificateUrl" alt="" :preview-src-list="srcList">
                                    </el-image>
                                    <el-image class="img" v-else :src="detail.certificateUrl" alt="" :preview-src-list="srcList">
                                    </el-image>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center" v-if="!isSightcing">
                        <div style="position: relative;">
                            <img class="computer" src="../../assets/img/index/computer.png" alt="">
                            <!-- <img class="medal" src="../../assets/img/index/medal.png" alt="" v-if="documentTitle == '星级诚信企业详情'"> -->
                            <video class="video" :src="baseUrl + detail.videoUrl" controls="controls"></video>
                        </div>
                    </div>
                    <div class="bottom"  v-if="!isSightcing">
                        <div class="title">
                            <div style="width: 6px;height: 20px;border-radius: 6px;background: linear-gradient(to bottom, #1A68E8, #fff);"></div>
                            <div class="text">宣传图片</div>
                        </div>
                        <div id="click-scroll-X">
                            <span class="left_btn el-icon-arrow-left" @click="leftSlide"></span>
                            <div class="scroll_wrapper" ref="wrapperCon">
                              <div class="scroll_list">
                                <div class="item" v-for="(item,index) in publicityList" :key="index">
                                    <img :src="baseUrl + item" alt="" @error="imgError">
                                </div>
                              </div>
                            </div>
                            <div class="right_btn el-icon-arrow-right" @click="rightSlide"></div>
                        </div>
                        <div class="foot">
                            <div class="group" v-if="detail.source">
                                <img src="../../assets/img/index/source.png" alt="">
                                <span>{{ detail.source }}</span>
                            </div>
                            <div class="group" style="margin-left: 30px;">
                                <img src="../../assets/img/index/time.png" alt="">
                                <span>{{ detail.updateTime }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <sideSearch></sideSearch>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
import sideSearch from '../../components/sideSearch.vue'
import {baseURL} from '../../api/network.js';
export default {
    name: 'starLevel',
    components: {
        publicHeaders,
        foot,
        sideSearch
    },
    data() {
        return {
            documentTitle: '',
            cateName: '',
            searchPlaceholder: '',
            baseUrl: baseURL,
            detail: {
                // companyName: '珠海格力电器股份有限公司',
                // uniscId: '91440400192548256N',
                // repName: '董明珠',
                // esdateDate: '1989-12-13',
                // regAddress: '广东省珠海市香洲区金鸡路',
                // regOrgan: '市场监督管理局',
                // scope: '货物、技术的进出口；研发、制造、销售：泵、阀门、压缩机及类似机械，风机、包装设备等通用设备；电机、输配电及控制设',
                // websiteLogo: require('../../assets/img/index/websiteLogo.png'),
                // mp4: require('../../assets/video/geli.mp4'),
                // source: '企业信用建设服务平台',
                // updateTime: '2023-05-14',
            },
            publicityList: [
                // {
                //     imgUrl: require('../../assets/img/index/publicity1.png')
                // },
                // {
                //     imgUrl: require('../../assets/img/index/publicity2.png')
                // },
                // {
                //     imgUrl: require('../../assets/img/index/publicity1.png')
                // },
                // {
                //     imgUrl: require('../../assets/img/index/publicity2.png')
                // },
                // {
                //     imgUrl: require('../../assets/img/index/publicity1.png')
                // },
                // {
                //     imgUrl: require('../../assets/img/index/publicity2.png')
                // },
            ],
            isNtoImg: false,
            isSightcing: false,
            srcList: [],
        }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        this.cateName = this.$route.query.documentTitle.replace('详情', '')
        this.searchPlaceholder = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        this.srcList = []

        if (this.$route.query.documentTitle == '诚信标杆企业详情' || this.$route.query.documentTitle == '诚信倡议单位详情') {
            this.isSightcing = true
        } else {
            this.isSightcing = false
        }

        this.getListStarInfo()
    },
    methods: {
        // 左箭头
        leftSlide() {
            // 保存滚动盒子左侧已滚动的距离
            let left = this.$refs.wrapperCon.scrollLeft
            let num = 0
            clearInterval(this.timer)
            this.timer = null
            this.timer = setInterval(() => {
                //   !left:已经滚动到最左侧
                //   一次性滚动距离（可调节）
                if (!left || num >= 300) {
                // 停止滚动
                clearInterval(this.timer)
                this.timer = null
                return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperCon.scrollLeft = left -= 32
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += 30
            }, 20)
            // 20：速度（可调节）
        },
        // 右箭头
        rightSlide() {
            // 保存滚动盒子左侧已滚动的距离
            let left = this.$refs.wrapperCon.scrollLeft
            // 保存元素的整体宽度
            let scrollWidth = this.$refs.wrapperCon.scrollWidth
            // 保存元素的可见宽度
            let clientWidth = this.$refs.wrapperCon.clientWidth
            let num = 0
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                // 已经滚动距离+可见宽度
                // left+clientWidth>=scrollWidth：滚动到最右侧
                // num>=300一次性滚动距离
                if (left + clientWidth >= scrollWidth || num >= 300) {
                clearInterval(this.timer)
                return
                }
                // 给滚动盒子元素赋值向左滚动距离
                this.$refs.wrapperCon.scrollLeft = left += 32
                // 保存向左滚动距离（方便判断一次性滚动多少距离）
                num += 30
            }, 20)
            // 20：速度（可调节）
        },


        // 获取详情
        getListStarInfo() {
            let _this = this
            let params = {
                id: this.$route.query.id
            }
            api.getListStarInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    
                    var imgRegExp = /\.(jpg|jpeg|png|gif|bmp)$/i;
                    if (data.data.certificateUrl == '' || data.data.certificateUrl == null) {
                        data.data.certificateUrl = ''
                    } else {
                        if (imgRegExp.test(data.data.certificateUrl)) {
                            data.data.certificateUrl = baseURL + data.data.certificateUrl
                            this.srcList.push(data.data.certificateUrl)
                        } else {
                            this.isNtoImg = true
                            data.data.certificateUrl = baseURL + data.data.certificateUrl
                        }
                    }

                    data.data.headImg = data.data.billboard.split(',')
                    _this.detail = data.data
                    _this.publicityList = data.data.headImg
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 图片错误
        imgError(e) {
            var img = e.srcElement;
            // console.log(img);
            img.src = require('../../assets/img/index/company.webp');
            img.onerror = null; //控制不要一直跳动 
        },

        // 点击查看文件
        lookFile(file) {
            window.open(file, '_blank');
        },
    }
}
</script>

<style lang="less" scoped>
.starLevel {
    position: relative;
    padding-bottom: 160px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            flex: 3;
            margin-right: 5px;
            width: 75%;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 500px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px;
                .top {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 30px;
                    .contentLeft {
                        width: 70%;
                        .title {
                            display: flex;
                            align-items: center;
                            font-size: 30px;
                            color: #1A68E8;
                            font-weight: 700;
                        }
                        .info {
                            font-size: 18px;
                            color: #333;
                            padding: 10px 0;
                        }
                    }
                    .contentRight {
                        /* display: inline-block;
                        border: 1px solid #D9D9D9;
                        background-color: #fff; */
                        padding: 10px;
                        /* cursor: pointer; */
                        span {
                            border: 1px solid #1A68E8;
                            color: #1A68E8;
                            padding: 5px 9px;
                        }
                        .img1 {
                            width: 200px;
                            height: 300px;
                            object-fit: contain;
                            /deep/ img {
                                object-fit: contain;
                            }
                        }
                        .img {
                            width: 300px;
                            height: 200px;
                            object-fit: contain;
                            /deep/ img {
                                object-fit: contain;
                            }
                        }
                    }
                }
                .center {
                    border-top: 1px solid #DCDCDC;
                    padding: 10px;
                    min-height: 700px;
                    margin-top: 60px;
                    .computer {
                        width: 800px;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                    }
                    .medal {
                        position: absolute;
                        bottom: 30px;
                        right: 40px;
                    }
                    .video {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 720px;
                        height: 416px;
                        top: 36px;
                    }
                }
                .bottom {
                    padding-bottom: 30px;
                    .title {
                        padding: 15px;
                        border-bottom: 1px solid #DCDCDC;
                        display: flex;
                        align-items: center;
                        .text {
                            font-size: 22px;
                            color: #333;
                            margin-left: 15px;
                        }
                    }
                    #click-scroll-X {
                        display: flex;
                        align-items: center;
                        margin-top: 30px;
                        /*隐藏滚动条*/
                        .scroll_wrapper::-webkit-scrollbar {
                            display: none;
                        }
                        .left_btn, .right_btn {
                            font-size: 20px;
                            cursor: pointer;
                            margin: -10px 15px 0;
                            color: #999;
                            padding: 3px;
                            border: 1px solid #1A68E8;
                            color: #1A68E8;
                            border-radius: 20px;
                        }

                        .scroll_wrapper {
                            width: 100%;
                            overflow-x: scroll;
                            padding-bottom: 10px;
                            width: 935px;

                            .scroll_list {
                                display: flex;
                                align-items: center;
                                justify-content: left;

                                .item {
                                    width: 285px;
                                    height: 175px;
                                    flex-shrink: 0;
                                    margin: 0 15px;
                                    position: relative;
                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                    }
                                }
                                .item:hover {
                                    background-color: #f3f9fd;
                                }
                            }
                        }
                    }
                    .foot {
                        display: flex;
                        justify-content: right;
                        align-items: center;
                        margin-top: 30px;
                        .group {
                            display: flex;
                            align-items: center;
                            font-size: 20px;
                            color: #666;
                            img {
                                width: 16px;
                                height: 16px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
        }
        .right {
            flex: 1;
            margin-left: 5px;
        }
    }
}
</style>
